interface ClassificacaoBadgeProps {
  classificacao: string;
  size?: 'sm' | 'md';
}

const config: Record<string, { bg: string; text: string; dot: string }> = {
  // Escala pré-2023
  Excelente:   { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  Relevante:   { bg: 'bg-teal-50',    text: 'text-teal-700',    dot: 'bg-teal-500'    },
  Adequado:    { bg: 'bg-amber-50',   text: 'text-amber-700',   dot: 'bg-amber-500'   },
  Inadequado:  { bg: 'bg-red-50',     text: 'text-red-700',     dot: 'bg-red-400'     },
  // Escala 2023+ (aliases de compatibilidade)
  'Muito Bom': { bg: 'bg-teal-50',    text: 'text-teal-700',    dot: 'bg-teal-500'    },
  Bom:         { bg: 'bg-amber-50',   text: 'text-amber-700',   dot: 'bg-amber-500'   },
  Regular:     { bg: 'bg-orange-50',  text: 'text-orange-700',  dot: 'bg-orange-400'  },
};

const fallback = { bg: 'bg-slate-100', text: 'text-slate-600', dot: 'bg-slate-400' };

export default function ClassificacaoBadge({ classificacao, size = 'sm' }: ClassificacaoBadgeProps) {
  const style = config[classificacao] ?? fallback;
  const sizeClass = size === 'md' ? 'px-3 py-1.5 text-sm' : 'px-2.5 py-1 text-xs';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${sizeClass} ${style.bg} ${style.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${style.dot}`} />
      {classificacao}
    </span>
  );
}
